import { get, post } from '../baseService'
import { RolePermissionModel } from 'app/models/rolePermissionModel'

const create = () => {
  const getRoles = () => get('/config-api/role')
  const addRole = (role: RolePermissionModel) =>
    post('/config-api/role/create', role, false)
  const editRole = (roles: Array<RolePermissionModel>) =>
    post('/config-api/role/edit', { roles: roles }, false)
  const deleteRole = (ids: string[]) =>
    Promise.all(
      ids.map((id) => post('/config-api/role/delete', { id }, false)),
    )

  return {
    getRoles,
    addRole,
    editRole,
    deleteRole,
  }
}

export default {
  create,
}
